// Removed delegate/exhibitor handling, currently login screen uses otp. This page is not required
import { Alert, Button, Divider, Form, Input, Modal } from "antd"
import Custom404 from "../404"
import { KeyOutlined } from "@ant-design/icons"
import { toastM } from "../components/Toast"
import { useRouter } from "next/router"
import { getExhibitorLoginScreen } from "../api/auth/login"
import moment from "moment"
import Link from "next/link"
import { useEffect, useRef, useState } from "react"
import { getCookieClientConfig, getCookies, getEventId, getSubdomainFromCookie, getSubdomainFromReq, getToken } from "../../helpers/utils"
import { resetPassOtp, resetPassConfirm } from '../../pages/api/exhibitors'
import { getConfig } from "../../config/getConfig"

const ResetPasswordPage = ({ error, errorCode, errorTitle, id, ...props }) => {
    const router = useRouter();
    const [modalOtp, setModalOtp] = useState(false);
    const [resetPassForm] = Form.useForm();
    const [otpForm] = Form.useForm();
    const [otp, setOtp] = useState('');
    const [countdown, setCountdown] = useState(null);
    const [config, setConfig] = useState({});

    useEffect(() => {
        async function ftechConfig() {
            try{
            const config = await getConfig();
            setConfig(config);
            }catch(e){
                console.log(e);
            }
        }
        ftechConfig();
    }, []);

    useEffect(() => {
        if (countdown != null) {
            let timer;
            if (countdown > 0) {
                timer = setTimeout(() => {
                    setCountdown((prev) => prev - 1);
                }, 1000);
                return () => clearTimeout(timer);
            } else {
                console.log('redirect');

                router.push('/login');
            }
            return () => {
                clearTimeout(timer);
            }
        }
    }, [countdown]);


    if (getCookieClientConfig()?.api_login_type != 20) {
        return <Custom404 />
    }
    const handleResetPass = async (values) => {
        sendOtp(values?.email)
    }

    const sendOtp = async (email) => {

        try {
            const res = await resetPassOtp(id || getEventId(), email);
            console.log(res);

            if (res?.data) {
                toastM.success(res?.data?.message ?? "OTP sent to your email id");
                setModalOtp(true);
            }
        }
        catch (e) {
            console.log('e', e);
            toastM.error(e?.response?.data?.message ?? "Something went wrong");
        }
    }

    const handleOtpSubmit = async (values) => {
        console.log('otp values', values);
        console.log('Form values all', { ...resetPassForm?.getFieldsValue(), otp });
        try {
            const res = await resetPassConfirm(id || getEventId(), resetPassForm.getFieldValue('password'), resetPassForm.getFieldValue('confirm_password'), otp);
            if (res.data) {
                toastM.success(res?.data?.message ?? 'Password reset successfully');
                setCountdown(5); //trigger re-direct

            }
        }
        catch (e) {
            toastM.error(res.message ?? 'Something went wrong');
        }
        otpForm.resetFields();
        resetPassForm.resetFields();
        setOtp('');
        setModalOtp(false);
    }

    return <div className="flex flex-col justify-center items-center h-full">
        <div className="w-full pl-3 md:pl-8 mt-8 lg:mt-0 text-center">
            <div className="flex flex-col justify-center">
                <div className={`font-bold ${props.event_logo ? 'text-xl' : 'text-5xl'} mt-10 mb-3 text-center`}>{props.event_name}</div>
                {props?.event_start_date && <div className="font-bold text-lg mb-3 text-center">
                    {
                        `${moment(props.event_start_date).format('MMM DD')}- ${moment(props.event_end_date).format('MMM DD, YYYY')}`
                    }
                </div>}
            </div>
            <div className="flex flex-row justify-center">
                {props.event_logo ? <img
                    alt=""
                    src={`${props.event_logo}`}
                    className="my-2 pb-3"
                    style={{ maxWidth: 300, maxHeight: 400 }}
                /> : <></>}
            </div>
        </div>
        {!error ?
            <div className="max-w-lg md:min-w-[500px] mx-auto my-10 bg-white p-8 rounded-xl shadow shadow-slate-300">
                <h1 className="text-3xl font-medium">Reset password</h1>
                <p className="text-slate-500 mt-2">Fill up the form to reset the password</p>
                {
                    countdown > 0 && <Alert message={`You will be redirected to event login page within ${countdown} seconds`} type="success" />
                }
                <Form
                    form={resetPassForm}
                    layout="vertical"
                    className="my-5"
                    onFinish={handleResetPass}
                >
                    <div className="flex flex-col space-y-3">
                        <Form.Item
                            label={<p className="font-medium text-slate-700 pb-2">Email/Phone</p>}
                            name="email"
                            rules={[{ required: true, message: 'Please enter your email or phone!' }]}
                        >
                            <Input
                                type="email"
                                placeholder="Enter email address"
                                className="w-full py-3 border border-slate-200 rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                            />
                        </Form.Item>

                        <Form.Item
                            label={<p className="font-medium text-slate-700 pb-2">New Password</p>}
                            name="password"
                            rules={[{ required: true, message: 'Please enter your new password!' }]}
                        >
                            <Input.Password
                                placeholder="Enter new password"
                                className="w-full py-3 border border-slate-200 rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                            />
                        </Form.Item>

                        <Form.Item
                            label={<p className="font-medium text-slate-700 pb-2">Confirm Password</p>}
                            name="confirm_password"
                            dependencies={['password']}
                            rules={[{ required: true, message: 'Please enter confirm password!' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    } else
                                        return Promise.reject(new Error('Confirm password should match with password'))
                                }
                            })
                            ]}
                        >
                            <Input.Password
                                placeholder="Confirm new password"
                                className="w-full py-3 border border-slate-200 rounded-lg px-3 focus:outline-none focus:border-slate-500 hover:shadow"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                icon={<KeyOutlined />}
                                type="primary"
                                htmlType="submit"
                                size="large"
                                className="w-full py-3 mt-3 font-medium text-white rounded-lg hover:shadow inline-flex space-x-2 items-center justify-center __primary_color_bg"
                            >
                                <span>Reset Password</span>
                            </Button>
                        </Form.Item>
                        <Divider className="text-gray-400">OR</Divider>
                        <Link href={'/'} passHref className="w-full">
                            <Button size="large" className="font-medium __primary_color w-full">
                                Go Back To Home
                            </Button>
                        </Link>
                    </div>
                </Form>
            </div> :
            <div className="flex justify-center items-center flex-col text-center text-red-500 text-2xl">
                {
                    errorTitle
                }
                <Link href="/" passHref>
                    <Button className="my-5">
                        Go Back To Home
                    </Button>
                </Link>
            </div>
        }

        <Modal
            title="Enter OTP"
            open={modalOtp}
            onCancel={() => setModalOtp(false)}
            footer={null}
            className="__modal_common"
        >
            <Form onFinish={handleOtpSubmit} form={otpForm}>
                <Form.Item name='otp'>
                    <div className="flex justify-center space-x-2">
                        <Input.OTP length={4} rules={[{ required: true, message: 'Please enter otp' }]} onChange={(values) => setOtp(values)} onInput={(e) => e?.target?.value == '' && setOtp('')} />
                    </div>
                </Form.Item>


                <Button
                    type="primary"
                    htmlType="submit"
                    className="w-full mt-5"
                    disabled={otp?.length !== 4}
                >
                    Verify OTP
                </Button>
            </Form>
        </Modal>
    </div>
}


export const getServerSideProps = async (context) => {
    const id = context.params.id

    const data = await getExhibitorLoginScreen(id, {}, context.req)
        .then(x => {
            // return {
            //     error: `couldn't find the thing`,
            //     errorCode: res,
            //     errorTitle: 'This Event is not Found or closed for Login'
            // }
            return (x)
        })
        .catch(e => {
            const res = e?.response?.status || 522
            return {
                error: `couldn't find the thing`,
                errorCode: res,
                errorTitle: 'This Event is not Found or closed for Login'
            }
        })

    return { props: { ...data, id } };
}

export default ResetPasswordPage;